import React from 'react';
import Link from 'next/link';

const CtaSection = () => {
  return (
    <section className="section bg-primary text-white">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to get started?</h2>
          <p className="text-xl opacity-90 mb-8">
            Get in touch with our team to see how Personalia can help you automate your creative workflows.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link href="/contact" className="btn bg-white text-primary hover:bg-opacity-90">
              Get in Touch
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
